<template>
  <span
      class="APPOINTMENT-BUBBLE ellipsize"
      :class="{ 'ACTIVE': active }"
      :selenium="`current-job-appointment`">
    {{ appointmentText }}
  </span>
</template>

<script>
import { PURPOSES_MAP } from '@/constants/appointments';

export default {
  name: 'appointment-bubble',
  props: {
    purpose: {
      type: String,
      default: '',
    },
    purposeDescription: {
      type: String,
    },
    active: Boolean,
    showType: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    appointmentPurpose () {
      if (this.purpose !== 'other') {
        return PURPOSES_MAP[this.purpose].short;
      }
      return this.purposeDescription || PURPOSES_MAP.other.short;
    },
    appointmentText () {
      return this.showType ? `Appointment - ${this.appointmentPurpose}` : 'Appointment';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .APPOINTMENT-BUBBLE {
    @include text-small;
    max-width: 100%;
    margin-top: 0.75*$unit;
    padding: $unit/4 0.75*$unit;
    align-self: flex-start;
    color: #575757;
    font-weight: 700;
    background-color: #EDEDED;
    border: 1px solid #EDEDED;
    border-radius: $unit*4;
  }
</style>
